import { Link } from "react-router";
import logoFooterEE from "@assets/events-awards/ee/logo-footer-ee.png";
import logoFooterEE2 from "@assets/events-awards/ee/logo-footer-ee-2.png";
import { EE_FOOTER_MENU } from "@ee/components/EEConstants";
import FooterMenuLinks from "@events-awards/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_EE_PATH } from "@events-awards/utils/constants";

/**
 * Component to display footer for desktop view in EE pages
 */
const EEFooterDesktop = (): React.ReactElement => {
  return (
    <div
      className="grid w-full grid-cols-12 text-center"
      data-testid="ee-footer-desktop-component"
    >
      <div className="col-span-2 pl-0 pr-3">
        <Link to={EVENTS_AWARDS_EE_PATH} reloadDocument>
          <img
            src={logoFooterEE}
            alt="Emerging Enterprise Awards logo"
            width={169}
            height={99}
            className="mb-6"
          />
          <img
            src={logoFooterEE2}
            alt="Emerging Enterprise Awards logo"
            width={169}
            height={99}
          />
        </Link>
      </div>

      <div className="col-span-4 pl-1 pr-3">
        <h3 className="mb-2 text-left font-poppins text-base font-semibold tracking-[1px]">
          About Us
        </h3>

        <p className="text-left leading-[1.4] text-white">
          No annual award better honours the bold ambition of young businesses
          under ten years old than the Emerging Enterprise Award and the
          Emerging Enterprise Sustainability Award. Since 2008, the award has
          been empowering startups and young enterprises with both recognition
          and resources to take flight and achieve stellar growth.
        </p>
      </div>

      <div className="col-span-3 px-3">
        <p className="mb-3 text-left font-semibold">Sections</p>

        <div className="my-2 flex flex-row">
          <FooterMenuLinks
            items={EE_FOOTER_MENU.slice(0, 3)}
            className="space-y-4"
          />

          <FooterMenuLinks
            items={EE_FOOTER_MENU.slice(3, 6)}
            className="space-y-4 pl-20"
          />
        </div>
      </div>

      <div className="col-span-2 pl-5 pr-3">
        <p className="mb-4 text-left font-semibold">Quick Links</p>

        <FooterMenuLinks
          items={EE_FOOTER_MENU.slice(6, 9)}
          className="space-y-4"
        />
      </div>
    </div>
  );
};

export default EEFooterDesktop;
